import { CircularProgress } from "@mui/material";
import React, { useState } from "react";
import {
  errorToaster,
  successToaster,
} from "../../../../../helper/toasterConfiguration";
import { Helper } from "../../../../../tools/Helper";
import { api_Routes } from "../../../../../tools/api_Routes";

const CountTicketChanger = ({
  item,
  service,
  status,
  setData,
  currentPage,
  rowsPerPage,
}) => {
  const [editingId, setEditingId] = useState(null);
  const [isEditingIdLoading, setIsEditingIdLoading] = useState(false);
  const [newCount, setNewCount] = useState("");
  const [pressed, setPressed] = useState(false);

  const handleInputChange = (e) => {
    setNewCount(e.target.value);
  };

  const handleKeyPress = async (e, id) => {
    if (e.key === "Enter" || pressed) {
      setIsEditingIdLoading(true);
      try {
        const { response, message } = await Helper.Put({
          url: `${api_Routes.TicketsAdvertising.UpdateCountTicket}${id}`,
          data: { count_ticket_send: newCount },
          hasToken: true,
        });

        if (response) {
          // Refresh the table data
          const { response: updatedData } = await Helper.Get({
            url: `${
              api_Routes.TicketsAdvertising.View
            }?per_page=${rowsPerPage}&page=${currentPage + 1}${
              status && status !== "null" ? `&status=${status}` : ""
            }${service && service !== "null" ? `&service=${service}` : ""}`,
            hasToken: true,
          });

          if (updatedData) {
            setData(updatedData);
            successToaster(message || "Count updated successfully");
          }
        } else {
          errorToaster(message || "Failed to update count");
        }
      } catch (error) {
        console.error("Error updating count_ticket_send:", error);
        errorToaster("An unexpected error occurred");
      } finally {
        setEditingId(null);
        setNewCount("");
        setIsEditingIdLoading(false);
        setPressed(false);
      }
    }
  };

  return isEditingIdLoading ? (
    <CircularProgress size={16} sx={{ color: "primary" }} />
  ) : editingId === item.id ? (
    <div className="flex flex-col">
      <span className="text-sm text-start mb-2">
        press Enter or press{" "}
        <span
          className="cursor-pointer text-blue-500 underline"
          onClick={(e) => {
            setPressed(true);
            handleKeyPress(e, item?.id);
          }}
        >
          here
        </span>{" "}
        to save
      </span>
      <input
        type="number"
        value={newCount}
        onChange={handleInputChange}
        onKeyDown={(e) => handleKeyPress(e, item.id)}
        className="border rounded px-2 py-1"
      />
    </div>
  ) : (
    <span
      className="cursor-pointer text-blue-500 underline"
      onClick={() => {
        setEditingId(item.id);
        setNewCount(item.count_ticket_send);
      }}
    >
      {item?.count_ticket_send}
    </span>
  );
};

export default CountTicketChanger;
